import { calculatePutOptionBasis } from './calculatePutOptionBasis';

export const calculateDiscountToStockPrice = (strikePrice: number, mid:number, stock_price: number) =>  {
    const net_cost_basis = calculatePutOptionBasis(strikePrice, mid);
    const discountToStockPrice = 1 - (net_cost_basis / stock_price);
    const percentStringDiscountToStockPrice = (discountToStockPrice * 100).toFixed(2) + '%';
    return percentStringDiscountToStockPrice;
};
